import { Route, Switch } from 'react-router';
import { connect } from 'react-redux';

import Layout from './../Layout';
import { ToxnotReactComponentPaths } from '../core/ToxnotReactComponentPaths';
import CompanyPagesManager from './CompanyPages/CompanyPagesManager';
import AccessRequestInbox from './AccessRequestInbox';
import MyPassports from './MyPassports/MyPassports';
import GrantGroupAccessInput from './GrantGroupAccessInput';
import StaticPageReloader from '../StaticPageReloader';
import { ApplicationState } from '../../store';
import * as SharedMaterialsManagementStateController from '../../store/StateControllers/SharedMaterials/SharedMaterialsManagementStateController';
import { ToxnotComponentProperties } from '../core/BaseApplicationComponents/ToxnotComponent';
import { ToxnotSignInRequiredComponent } from '../core/BaseApplicationComponents/ToxnotSignInRequiredComponent';
import { LoadingSpinner, LoadingSpinnerSize } from '../core/LoadingSpinner';


type SharedMaterialsManagementProps =
    SharedMaterialsManagementStateController.ManagementState &
    typeof SharedMaterialsManagementStateController.actionCreators &
    ToxnotComponentProperties;

export class SharedMaterialsManagement extends ToxnotSignInRequiredComponent<SharedMaterialsManagementProps> {

    // ===============================================================================

    public componentDidMount() {
        this.props.loadManagementState();
    }

    // ===============================================================================

    protected override getDisallowedRoles() {
        return [];
    }

    // ===============================================================================

    protected renderConcreteComponent() {
        if (this.props.loading) {
            return (
                <div className="text-center">
                    <LoadingSpinner size={ LoadingSpinnerSize.Medium} />
                </div>
            );
        }
        return (
            <Switch>
                <Route exact={true} path={ToxnotReactComponentPaths.CompanyPagesManager} component={CompanyPagesManager} />
                <Route exact={true} path={ToxnotReactComponentPaths.MyPassports} component={MyPassports} />
                <Layout>
                    <Switch>
                        <Route exact={true} path={ToxnotReactComponentPaths.AccessRequestInbox} component={AccessRequestInbox} />
                        <Route exact={true} path={ToxnotReactComponentPaths.GrantGroupAccessInput} component={GrantGroupAccessInput} />
                        <Route component={StaticPageReloader} />
                    </Switch>
                </Layout>
            </Switch>
            
        );
    }
}

// ===============================================================================

export default connect(
    (state: ApplicationState) => ({ ...state.sharedMaterialsManagementState, appServices: state.appServices }),
    SharedMaterialsManagementStateController.actionCreators // Selects which action creators are merged into the component's props
)(SharedMaterialsManagement as any);
